"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = require("app");
var React = require("react");
var FilterableList_1 = require("Views/Partials/Components/FilterableList");
var FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
var index_1 = require("../index");
var dictionary_1 = require("./dictionary");
var DataService_1 = require("./services/DataService");
var SearchResultsContainer_1 = require("./components/SearchResultsContainer");
var FullTextSearchApi_1 = require("src/search/fullText/FullTextSearchApi");
var SearchResultsService_1 = require("./services/SearchResultsService");
require("./style.scss");
var element = document.getElementById('search-results-page-react');
var pageType = FilterTypings_1.FilterableListTypeEnum.SearchResults;
var isDocumentsSearchPage = app_1.AttrService.data(element, 'is-documents-search-page');
var dictionary = (0, app_1.transformDictionary)(dictionary_1.searchPageDictionary, app_1.AttrService.data(element, 'dictionary'));
var transformDocumentsHierarchyConfiguration = function (hierarchyConfigurationObject, documentsSegmentsPrefix) {
    var transformedObject = {};
    Object.keys(hierarchyConfigurationObject).forEach(function (key) {
        var newKey = "".concat(documentsSegmentsPrefix, ":").concat(key.toLowerCase());
        transformedObject[newKey] = hierarchyConfigurationObject[key];
    });
    return transformedObject;
};
var hierarchyConfiguration = app_1.AttrService.data(element, 'hierarchy-configuration');
var documentsSearchPageType = isDocumentsSearchPage
    ? SearchResultsService_1.SearchResultsService.getDocumentSearchPageTypeFromUrl()
    : FullTextSearchApi_1.FullTextSearcherTypes.Documentation;
var additionalData = {
    contentPage: document.querySelector('.dynamic-page'),
    zeroResultsText: app_1.AttrService.data(element, 'zero-results-text'),
    zeroResultsTitle: app_1.AttrService.data(element, 'zero-results-title'),
    allResultsLabel: app_1.AttrService.data(element, 'all-results-label'),
    isDocumentsSearchPage: isDocumentsSearchPage && isDocumentsSearchPage.toLocaleLowerCase() === 'true',
    documentsSearchPageType: documentsSearchPageType,
    documentsHierarchyConfiguration: transformDocumentsHierarchyConfiguration(hierarchyConfiguration, FullTextSearchApi_1.FullTextSearchFilters.DocumentationSegmentFilterAlias),
    drawingsHierarchyConfiguration: transformDocumentsHierarchyConfiguration(hierarchyConfiguration, FullTextSearchApi_1.FullTextSearchFilters.DrawingsSegmentFilterAlias),
    downloadHierarchyConfiguration: transformDocumentsHierarchyConfiguration(hierarchyConfiguration, FullTextSearchApi_1.FullTextSearchFilters.DownloadSegmentFilterAlias),
    approvalType: dictionary.approvalType,
};
index_1.PageContext.initContext(pageType, element, dictionary);
document.querySelector('.main-content').classList.add('main-content-dynamic');
var serviceConfig = (0, FilterableList_1.createFilterableDataServiceConfig)(pageType, element, dictionary);
var dataService = (0, FilterableList_1.createFilterableDataService)(DataService_1.DataService, serviceConfig);
(0, app_1.reactDOMRender)(React.createElement(SearchResultsContainer_1.SearchResultsContainer, { service: dataService, additionalData: additionalData }), element);
